import { render, staticRenderFns } from "./403.vue?vue&type=template&id=4547cb71&scoped=true"
import script from "./403.vue?vue&type=script&lang=js"
export * from "./403.vue?vue&type=script&lang=js"
import style0 from "./403.vue?vue&type=style&index=0&id=4547cb71&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4547cb71",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4547cb71')) {
      api.createRecord('4547cb71', component.options)
    } else {
      api.reload('4547cb71', component.options)
    }
    module.hot.accept("./403.vue?vue&type=template&id=4547cb71&scoped=true", function () {
      api.rerender('4547cb71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/403.vue"
export default component.exports